<div class="modal-close-button" (click)="onCancel()">
  <em class="icon-close_medium"></em>
</div>

<div class="content">
  <div class="title">
    <em class="icon-warning" aria-hidden="true"></em>
    <span>{{ props.title }}</span>
  </div>

  <div class="body">
    {{ props.body }}
  </div>

  <div class="modal-footer">
    <button class="btn-modal-secondary" (click)="onCancel()">
      {{ props.closeButtonLabel }}
    </button>
    <button class="btn-modal-primary" (click)="onProceed()">
      {{ props.actionButtonLabel }}
    </button>
  </div>

  <div class="checkbox">
    <app-checkbox
      [props]="checkboxProps"
      [(ngModel)]="checkboxState"
      (ngModelChange)="onClickCheckbox($event)"
    ></app-checkbox>
  </div>
</div>
